// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__cx5Ot","button--hightlight":"styles_button--hightlight__DGkpA"};